import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchFormsList = (formType) => apiActionCreator({
  'endpoint': `/forms?type=${formType}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_FORMS_LIST,
    ActionTypes.FETCHED_FORMS_LIST,
    [
      ActionTypes.FETCHED_FORMS_LIST_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'form',
  'method': 'GET',
});

export const clearForms = () => ({
  'type': ActionTypes.CLEAR_FORMS_LIST,
});
